export const SEND_VALIDATE_ACCOUNT_MAIL_FETCH = 'SEND_VALIDATE_ACCOUNT_MAIL_FETCH'
export const SEND_VALIDATE_ACCOUNT_MAIL_SUCCESS = 'SEND_VALIDATE_ACCOUNT_MAIL_SUCCESS'
export const SEND_VALIDATE_ACCOUNT_MAIL_ERROR = 'SEND_VALIDATE_ACCOUNT_MAIL_ERROR'
export const SEND_VALIDATE_ACCOUNT_MAIL_RESET = 'SEND_VALIDATE_ACCOUNT_MAIL_RESET'
export const VALIDATE_ACCOUNT_FETCH = 'VALIDATE_ACCOUNT_FETCH'
export const VALIDATE_ACCOUNT_SUCCESS = 'VALIDATE_ACCOUNT_SUCCESS'
export const VALIDATE_ACCOUNT_ERROR = 'VALIDATE_ACCOUNT_ERROR'
export const VALIDATE_ACCOUNT_RESET = 'VALIDATE_ACCOUNT_RESET'
export const IS_VALIDATED_FETCH = 'IS_VALIDATED_FETCH'
export const IS_VALIDATED_SUCCESS = 'IS_VALIDATED_SUCCESS'
export const IS_VALIDATED_ERROR = 'IS_VALIDATED_ERROR'
export const IS_VALIDATED_RESET = 'IS_VALIDATED_RESET'

/**
 * Send Validate Account Mail
 */
export interface SendValidateAccountMailFetch {
  type: typeof SEND_VALIDATE_ACCOUNT_MAIL_FETCH
  payload: null
}

export interface SendValidateAccountMailSuccess {
  type: typeof SEND_VALIDATE_ACCOUNT_MAIL_SUCCESS
  payload: null
}

export interface SendValidateAccountMailError {
  type: typeof SEND_VALIDATE_ACCOUNT_MAIL_ERROR
  payload: null
}

export interface SendValidateAccountMailReset {
  type: typeof SEND_VALIDATE_ACCOUNT_MAIL_RESET
  payload: null
}

/**
 * Validate Account
 */

export interface ValidateAccountFetch {
  type: typeof VALIDATE_ACCOUNT_FETCH
  payload: null
}

export interface ValidateAccountSuccess {
  type: typeof VALIDATE_ACCOUNT_SUCCESS
  payload: null
}

export interface ValidateAccountError {
  type: typeof VALIDATE_ACCOUNT_ERROR
  payload: null
}

export interface ValidateAccountReset {
  type: typeof VALIDATE_ACCOUNT_RESET
  payload: null
}

/**
 * Is Validated
 */

export interface IsValidatedFetch {
  type: typeof IS_VALIDATED_FETCH
  payload: null
}

export interface IsValidatedSuccess {
  type: typeof IS_VALIDATED_SUCCESS
  payload: boolean
}

export interface IsValidatedError {
  type: typeof IS_VALIDATED_ERROR
  payload: null
}

export interface IsValidatedReset {
  type: typeof IS_VALIDATED_RESET
  payload: null
}

/**
 * Status
 */

export enum ValidateAccountStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface ValidateAccountState {
  mailStatus: ValidateAccountStatus
  validationStatus: ValidateAccountStatus
  isValidatedStatus: ValidateAccountStatus
  isValidCompanyAccount: boolean | null
}

export const initialState: ValidateAccountState = {
  mailStatus: ValidateAccountStatus.Idle,
  validationStatus: ValidateAccountStatus.Idle,
  isValidatedStatus: ValidateAccountStatus.Idle,
  isValidCompanyAccount: null,
}

export type ValidateAccountActions =
  | SendValidateAccountMailFetch
  | SendValidateAccountMailSuccess
  | SendValidateAccountMailError
  | SendValidateAccountMailReset
  | ValidateAccountFetch
  | ValidateAccountSuccess
  | ValidateAccountError
  | ValidateAccountReset
  | IsValidatedFetch
  | IsValidatedSuccess
  | IsValidatedError
  | IsValidatedReset
